const paths = {
  play: '<path d="M6 4l14 8-14 8z" fill="currentColor" stroke="none"/>',
  torch: '<path d="m13 2-9 12h7l-1 8 10-12h-7l1-8Z"/>',
  scan: '<path d="M8 3H5a2 2 0 0 0-2 2v3m13-5h3a2 2 0 0 1 2 2v3M3 16v3a2 2 0 0 0 2 2h3m8 0h3a2 2 0 0 0 2-2v-3"/><rect x="8" y="6" width="8" height="12" rx="1"/>',
  stop: '<rect x="3" y="3" width="18" height="18" rx="3" fill="currentColor" stroke="none"/>',
  cards:
    '<rect x="8" y="3" width="12" height="16" rx="2"/><path d="M5 7H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10"/>',
  settings:
    '<path d="m9 3-.5 2-2 .9L4.5 5 2 9l1.5 1.5v3L2 15l2.5 4 2-1 2 .9L9 21h5l.5-2 2-.9 2 1L21 15l-1.5-1.5v-3L21 9l-2.5-4-2 1-2-.9L14 3Z"/><circle cx="11.5" cy="12" r="3"/>',
  arrow: '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  back: '<path d="M20 12H4m6-6-6 6 6 6"/>',
  close: '<path d="m6 6 12 12M6 18 18 6"/>',
  sliders:
    '<path stroke-width="2" d="M21 4h-7m-4 0H3m18 8h-9m-4 0H3m18 8h-5m-4 0H3M14 2v4M8 10v4M16 18v4"/>',
} as const;

export function icon(name: keyof typeof paths): SVGSVGElement {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "1.6");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  svg.setAttribute("aria-hidden", "true");
  svg.classList.add("icon");
  svg.innerHTML = paths[name];
  return svg;
}

export function mountIcons(): void {
  for (const node of document.querySelectorAll<HTMLElement>("[data-icon]")) {
    const name = node.dataset.icon;
    if (name && name in paths) node.replaceChildren(icon(name as keyof typeof paths));
  }
}
